/** משתני סביבה ציבוריים בלבד. סודות לא מגיעים לממשק (PRD 2.9). */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`חסר משתנה סביבה: ${name}. ראו .env.example`);
  }
  return value;
}

const supabaseUrl = required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL);

/**
 * האם השרת הוא הסביבה המקומית. בפיתוח, חיבור לכל דבר אחר אומר שאנחנו
 * נוגעים בנתונים אמיתיים של עובדים, ולכן הוא מוצג על המסך ולא מונח
 * על הזיכרון של מי שהריץ את הפקודה.
 */
/**
 * כתובת ברשת הפרטית נחשבת מקומית גם היא. כדי לבדוק את האפליקציה
 * בטלפון מפנים אותו אל המחשב ברשת הביתית, והשרת שם הוא אותו סטאק
 * מקומי בדיוק. עם loopback בלבד האזהרה צעקה "ייצור" על הסביבה
 * המקומית, וצעקת שווא היא מה שמלמד להתעלם מאזהרות.
 */
export function isLocalHost(url: string): boolean {
  const host = url.match(/^https?:\/\/(\[[^\]]+\]|[^/:]+)/i)?.[1]?.toLowerCase();
  if (!host) return false;

  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '[::1]' ||
    host.endsWith('.localhost') ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host) ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(host)
  );
}

const isLocalSupabase = isLocalHost(supabaseUrl);

export const env = {
  supabaseUrl,
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY ?? '',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '',
  isLocalSupabase,
  /** פיתוח שמחובר לייצור: המצב היחיד שמצדיק אזהרה קבועה על המסך. */
  isTouchingProduction: import.meta.env.DEV && !isLocalSupabase,
};
